<div class="backdrop" (click)="onClose()"></div>
<div class="slide-panel client-summary-slider-panel">
  <!-- CITC Header -->
  <div class="citc-header">
    <div class="header-left">
      <div class="project-select-section">
        <ng-select [(ngModel)]="selectedPortfolio" [items]="portfolios()" bindLabel="portfolioName" [clearable]="false"
          [searchable]="true" [loading]="isLoadingPortfolios()" (ngModelChange)="onPortfolioChange($event)"
          placeholder="Select a Portfolio" class="project-dropdown">
        </ng-select>
      </div>
    </div>

    <div class="header-center">
      <div class="account-manager-info">

        <div class="manager-details">
          <div class="manager-icon">
            <!-- <i class="wl_icon_current-am"></i> -->
            <img src="assets/images/am.svg" alt="Current AM" class="manager-icon-image">

          </div>
          <div class="info-label-container">
            <span class="info-label">Current AM</span>
            <span class="manager-name">McKenna Lacheur</span>
          </div>
        </div>
      </div>
      <div class="active-status">

        <div class="status-indicator">
          <div class="status-icon">
            <!-- <i class="wl_icon_true"></i> -->
            <img src="assets/images/true.svg" alt="Current AM" class="manager-icon-image">
          </div>
          <div class="info-label-container">
            <span class="status-label">Is Active</span>
            <span class="status-text">True</span>
          </div>
        </div>
      </div>
    </div>

    <div class="header-right">
      <div class="search-container">
        <input #searchInput type="text" placeholder="Search Anything" class="search-input" [ngModel]="searchQuery()"
          (ngModelChange)="onSearchChange($event)" (input)="onSearchChange(searchInput.value)"
          (keyup.enter)="onSearchChange(searchInput.value)">
        <button class="search-icon-btn" (click)="onSearchChange(searchInput.value)">
          <mat-icon class="search-icon">search</mat-icon>
        </button>
        <button *ngIf="searchQuery()" class="search-icon-btn" (click)="onSearchClear()">
          <mat-icon class="search-icon">close</mat-icon>
        </button>
      </div>
      <button class="close-search-icon" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Filter and Sort Bar -->
  <div class="filter-sort-bar">
    <div class="filter-section">
      <ng-select [(ngModel)]="selectedDepartment" [items]="departments()" bindLabel="name" [clearable]="false"
        [searchable]="false" [loading]="isLoadingDepartments()" placeholder="Filter By Department"
        class="department-filter" (ngModelChange)="onDepartmentChange($event)">
        <ng-template ng-label-tmp let-item="item">
          <div class="filter-label-wrapper">
            <span class="filter-label">Filter By Department</span>
            <span class="filter-value">{{ item.name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>
    <div class="sort-section">
      <ng-select [(ngModel)]="selectedSort" [items]="sortOptions" bindLabel="name" [clearable]="false"
        [searchable]="false" class="sort-dropdown" (ngModelChange)="onSortChange($event)">
        <ng-template ng-label-tmp let-item="item">
          <div class="sort-label-wrapper">
            <mat-icon class="sort-icon">swap_vert</mat-icon>
            <span class="sort-label">{{ item.name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading()" class="loading-container">
    <div class="loader-content">
      <app-spinner [size]="40"></app-spinner>
    </div>
  </div>

  <!-- Notes Content -->
  <div class="notes-content" *ngIf="!isLoading()">
    <div *ngIf="filteredNotes().length === 0 && !noDataFound() && !searchQuery()" class="no-data-container">
      <div class="no-data-content">
        <i class="wl_icon_client-edit no-data-icon"></i>
        <div class="no-data-text">No pinned notes available</div>
        <div class="no-data-subtext">Pin important notes to see them here in the client summary</div>
      </div>
    </div>
    <div *ngIf="filteredNotes().length === 0 && !noDataFound() && searchQuery()" class="no-search-results-container">
      <div class="no-search-results-content">
        <i class="wl_icon_client-edit no-search-results-icon"></i>
        <div class="no-search-results-text">No results found for "{{ searchQuery() }}"</div>
        <div class="no-search-results-subtext">Try adjusting your search terms or clear the search to see all notes
        </div>
      </div>
    </div>
    <div *ngIf="noDataFound()" class="no-data-container">
      <div class="no-data-content">
        <i class="wl_icon_client-edit no-data-icon"></i>
        <div class="no-data-text">No summary data found</div>
        <div class="no-data-subtext">There are no summary notes available for this client/portfolio</div>
      </div>
    </div>

    <div *ngIf="hasError()" class="error-container">
      <div class="error-content">
        <i class="wl_icon_client-edit error-icon"></i>
        <div class="error-text">{{ errorMessage() }}</div>
        <div class="error-subtext">Please try again or contact support if the problem persists</div>
      </div>
    </div>

    <div *ngFor="let note of filteredNotes(); let i = index" class="citc-note-card">
      <!-- Card Header -->
      <div class="card-header">
        <div class="user-info">
          <div class="user-avatar">
            @if (note.userImage && note.userImage.trim() !== '') {
            <img [src]="note.userImage" [alt]="note.user + ' avatar'" class="avatar-image"
              (error)="onImageError($event)" />
            <div class="avatar-placeholder" [style.background-color]="getAvatarColor(note.user)" style="display: none;">
              {{ getInitials(note.user) }}
            </div>
            } @else {
            <div class="avatar-placeholder" [style.background-color]="getAvatarColor(note.user)">
              {{ getInitials(note.user) }}
            </div>
            }
          </div>
          <div class="user-details">
            <div class="user-name">{{ note.user }}</div>
            <div class="note-date">{{ note.date }}</div>
          </div>
        </div>

        <!-- Card Badge and Title Container -->
        <div class="card-title-section">
          <div class="card-badge">
            <span class="badge-tag" [ngClass]="getBadgeClass(note)">
              {{ getBadgeText(note) }}
            </span>
          </div>
          <div class="card-title">{{ note.title }}</div>
        </div>
        <div class="card-actions">
          <button class="view-pin-btn" (click)="onViewPinClick(note)">View Pin</button>
          <!-- <i class="wl_icon_pin"></i> -->
          <div class="more-options-wrapper">
            <i class="wl_icon_doc-3dot" [ngClass]="{ 'active': isDropdownActive(note.id) }"
              (click)="toggleNoteDropdown($event, note.id)">
            </i>

            <!-- Dropdown Menu -->
            <div class="note-dropdown" *ngIf="isDropdownActive(note.id)">

              <!-- <button class="dropdown-item">
                <i class="wl_icon_share"></i>
                Share
              </button>
              <button class="dropdown-item">
                <i class="wl_icon_edit"></i>
                Edit
              </button> -->
              <div class="dropdown-divider"></div>
              <button class="dropdown-item delete" (click)="removeFromClientSummary(note.id)">
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Card Content -->
      <div class="card-content">
        <!-- API Content (HTML from textHTML) -->
        <div *ngIf="note.content.textHTML" class="api-content">
          <div class="html-content" [innerHTML]="note.content.textHTML"></div>
        </div>

        <!-- Links Content -->
        <!-- <div *ngIf="note.type === 'links'" class="links-content">
          <div class="greeting">{{ note.content.greeting }}</div>
          <div class="link-item">
            <span class="link-label">Url :</span>
            <a [href]="note.content.url" target="_blank" class="link-url">{{ note.content.url }}</a>
          </div>
          <div class="link-item">
            <span class="link-label">Doc :</span>
            <a [href]="note.content.docUrl" target="_blank" class="link-url">{{ note.content.docUrl }}</a>
          </div>
          <ul class="bullet-points">
            <li *ngFor="let point of note.content.bulletPoints">{{ point }}</li>
          </ul>
        </div> -->

        <!-- Images Content -->
        <!-- <div *ngIf="note.type === 'images'" class="images-content">
          <div class="image-grid">
            <div class="image-item large" *ngIf="note.content.images && note.content.images[0]">
              <img [src]="note.content.images[0]" alt="Image 1" class="grid-image">
            </div>
            <div class="image-item small" *ngIf="note.content.images && note.content.images[1]">
              <img [src]="note.content.images[1]" alt="Image 2" class="grid-image">
            </div>
            <div class="image-item small" *ngIf="note.content.images && note.content.images[2]">
              <img [src]="note.content.images[2]" alt="Image 3" class="grid-image">
            </div>
          </div>
        </div> -->
        <div *ngIf="note.type === 'document'" class="document-content">
          <!-- API Document with Image -->
          <div *ngIf="note.content.docServerURL" class="api-document-display">
            <div class="document-image-container">
              <img [src]="note.content.docServerURL" [alt]="note.content.docName" class="document-image"
                (error)="onImageError($event)">
            </div>
            <!-- <div class="document-info">
              <div class="document-name">{{ note.content.docName }}</div>
              <div class="document-details">
                <span class="document-size">{{ note.content.docSize }}</span>
                <span class="document-format">{{ note.content.docFormat }}</span>
              </div>
            </div> -->
          </div>

          <!-- Fallback: PDF Content -->
          <div *ngIf="!note.content.docServerURL" class="pdf-content">
            <div class="pdf-display">
              <div class="pdf-icon"> <i class="wl_icon_client-pdf"></i></div>
              <span class="pdf-filename">{{ note.content.fileName }}</span>
            </div>
          </div>
        </div>
        <!-- PDF Content -->
        <!-- <div *ngIf="note.type === 'document'" class="pdf-content">
          <div class="pdf-display">
            <div class="pdf-icon"> <i class="wl_icon_client-pdf"></i></div>
            <span class="pdf-filename">{{ note.content.fileName }}</span>
          </div>
        </div> -->

        <!-- Table Content -->
        <!-- <div *ngIf="note.type === 'table'" class="table-content">
          <div class="greeting">{{ note.content.greeting }}</div>
          <div class="table-text">{{ note.content.tableText }}</div>
          <div class="table-wrapper">
            <table class="data-table table-bordered">
              <thead>
                <tr>
                  <th *ngFor="let header of note.content.tableHeaders">{{ header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of note.content.tableData">
                  <td *ngFor="let cell of row">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <app-confirm-popup [show]="showConfirmPopup()" title="Remove from Client Summary"
    message="Are you sure you want to remove this item from the client summary? This action cannot be undone."
    confirmText="Remove" cancelText="Cancel" type="delete" [loading]="isRemoving()" (confirm)="onConfirmRemove()"
    (cancel)="onCancelRemove()">
  </app-confirm-popup>
</div>